import React from 'react';
import './style.css';

export const Copyright = () => (
  <div className='copyright'>
    <p>
      <span className='copyright__symbol' alt='copyright symbol'>
        ©
      </span>{' '}
      2018-2026 Interconnections Counseling, LLC.
      <br />
      Last Modified 01/13/2026
    </p>
  </div>
);

export default Copyright;
